<template>
  <v-row dense>
    <v-col cols="12" md="6" sm="12">
      {{ $t('rgpd.dateCreation.' + genre) }}
      <span v-if="form.dateCreation">{{ formatDate(form.dateCreation) }}</span>
      {{ $t('rgpd.chargeCreation') }}
      <span v-if="form.chargeCreation">{{ form.chargeCreation }}</span>
      <span
        v-if="form.demandeurCreation && form.demandeurCreation != 'Reprise'"
      >
        ({{ $t('rgpd.demandeurCreation') }} {{ form.demandeurCreation }})</span
      >
    </v-col>
    <v-col cols="12" md="6" sm="12">
      {{ $t('rgpd.dateModification.' + genre) }}
      <span v-if="form.dateModification">{{
        formatDate(form.dateModification)
      }}</span>
      {{ $t('rgpd.chargeModification') }}
      <span v-if="form.chargeModification">{{ form.chargeModification }}</span>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    form: {},
    genre: {
      type: String,
      default: 'M',
    },
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY [à] HH:mm') : null;
    },
  },
};
</script>
